import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async findOne(id, opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos(`pagos-universidades-padres-reportes/${id}`), opciones);
  },
  async findOneV2(id, opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos(`pagos-universidades-padres-reportes/${id}/v2`), opciones);
  },
};
